export interface DecodedToken {
  sub: string;
  'cognito:groups': string[];
  event_id: string;
  token_use: string;
  scope: string;
  auth_time: number;
  iss: string;
  exp: number;
  iat: number;
  jti: string;
  client_id: string;
  username: string;
}

/**
 * Token model
 * @property {string}  refreshToken   - Value with time to update token
 * @property {string}  accessToken    - Token value
 * @property {Array}   roles          - User list of roles
 */

export class Token {
  id: string;
  roles: string[];
  username: string;
  constructor(token: Partial<Token> = {}) {
    Object.assign(this, token);
  }
}